import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-fatura-detay-goster',
  templateUrl: 'fatura-detay-goster.html',
})
export class FaturaDetayGosterPage {
  belgeno = "";
  hareketListesi = [];
  edit: any = { Miktar: "", Fiyat: "", ID: "" };
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public actionSheetCtrl: ActionSheetController,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("belgeno") != null) {
      this.belgeno = navParams.get("belgeno");
    }
  }

  ionViewDidLoad() {
    this.FaturaGetir();
  }
  FaturaGetir() {
    var formdata = new FormData();
    formdata.append("belgeno", this.belgeno.toString());
    this.bllOrtak.islem(formdata, "FaturaDetayiGetir", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.hareketListesi = sonuc.SonucObject;
    })
  }
  Kapat() {
    this.viewCtrl.dismiss();
  }
  Islemler(hareket) {
    const actionSheet = this.actionSheetCtrl.create({
      title: hareket.StokAdi,
      buttons: [
        {
          text: 'Kalemi Sil',

          handler: () => {
this.KalemiSil(hareket);
          }

        },
        {
          text: 'Kalemi  Düzenle',

          handler: () => {
            this.KalemiDuzenle(hareket);
          }

        },
        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  KalemiSil(hareket) {
    var formdata=new FormData();
    formdata.append("stharid",hareket.ID.toString());
    this.bllOrtak.islem(formdata,"FaturaKalemSil","",false).then(a=>{
      var sonuc=<any>a;
         if(sonuc.Sonuc==1)this.ortak.showBasicAlert("Başarılı","Kalem Silindi");
      if(sonuc.Sonuc!=1)this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      this.FaturaGetir();
    })

  }

  KalemiDuzenle(hareket) {
    this.ortak.alertKalemGuncelle(hareket).then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      this.edit.Fiyat = values.fiyat;
      this.edit.Miktar = values.miktar;
      this.edit.ID = hareket.ID;
      var formdata = new FormData();
      formdata.append("stharid", this.edit.ID.toString());
      formdata.append("fiyat", this.edit.Fiyat.toString());
      formdata.append("miktar", this.edit.Miktar.toString());
     this.bllOrtak.islem(formdata, "FaturaKalemEdit", "İşlem Yapılıyor..", true).then(b => {
       var sonuc = <any>b;
       if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "Fatura Kalemi Başarılı Bir Şekilde Güncellendi");
       if (sonuc.Sonuc != 1) this.ortak.showBasicAlert("Hata", "Beklenmedik Bir Hata Oluştu");
       this.FaturaGetir();
     })
    })
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/fatura-detay-goster/fatura-detay-goster.ts